import { render, staticRenderFns } from "./no-access.vue?vue&type=template&id=9d80d65c&scoped=true"
import script from "./no-access.vue?vue&type=script&lang=js"
export * from "./no-access.vue?vue&type=script&lang=js"
import style0 from "./no-access.vue?vue&type=style&index=0&id=9d80d65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d80d65c",
  null
  
)

export default component.exports